// extracted by mini-css-extract-plugin
export default {"quantitySelect":"H3uhLX4Rv1cbO1KPBSqS","staticQuantity":"fIkIrrVitqWZtfhp2eYg"};